<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" class="mb-3" ></spinner>


    <div class="page pt-3 pb-3" v-else-if="loaded" >
        
        <div class="pl-3 pr-3 mb-1" v-if="CHART_COMPONENT == 'regular' && TITLE != '' "   >
            <h4 class="font-size-14 graymedium-color font-600"> {{ TITLE }} </h4>

            <div class="row no-gutters" >
                <div class="col-6" > <h2 class="h2 main-color font-400"> {{ renderAmount( CHART_TOTAL ) }} </h2> </div>
            </div>
            <div class="row no-gutters d-none"  >
                <div class="col-6" > <h4 class="h4 main-color font-400"> Today </h4> </div>
            </div>
        </div>
        
        <div class="pl-3 pr-3 mb-1 pb-3" v-if="CHART_COMPONENT != 'regular' && TITLE != '' " >
            <div class="row no-gutters" >
                
                <div class="col" > 
                    <h2 class="h2 graymedium-color font-600"> 
                        {{ TITLE }} 
                        <span class="font-size-10"  > 
                            <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-charttitle-${TITLE}`" style="margin-top: -8px;" />  
                            <b-tooltip :target="`tooltip--info-charttitle-${TITLE}`" placement="right" triggers="hover" custom-class="" >
                                <span v-if="TITLE == 'MRR'" > Monthly Recurring Revenue </span>
                                <span v-else-if="TITLE == 'ARPU'" > Average Revenue Per User ( Customer ) </span>
                                <span v-else-if="TITLE == 'AOV'" > Average Order Value </span>
                                <span v-else-if="TITLE == 'LTV'" > Lifetime Value </span>
                                <span v-else="" > {{ TITLE }} </span>
                                
                                
                                <div class="mt-2" > Read more on how we calculate all stats <a @click="goToResource('metrics-explained')" class="cursor-pointer Text-color--white" > here </a> </div>
                            </b-tooltip>
                        </span>
                    </h2> 
                </div>
                <div class="col-auto text-right" v-if="symbol == ''" > <h2 class="h2 graymedium-color font-400"> {{ renderAmount( CHART_TOTAL ) }} </h2> </div>
                <div class="col-auto text-right" v-else-if="symbol != ''"  > <h2 class="h2 graymedium-color font-400"> {{ renderAmount( CHART_TOTAL, 'number' ) }} </h2> </div>
                
            </div>
        </div>
        
        <barChart_full :chart-data="CHART_SERIES"  :labels="CHART_COLUMNS" :width="450" :height="HEIGHT" :symbol="ChartSymbol" :chartOptions="chartOptions" ></barChart_full>
        
        <!-- HANDLE DATA ERROR -->
        <div class="w-100 mt-3 pt-5 text-center position-absolute top-0 h-100" style="background: rgba(255,255,255,0.7)" v-if="error != false" > {{ error }} </div>
        <!-- HANDLE DATA ERROR -->
        
    </div>
</template>

<script>
import {_} from 'vue-underscore';

import lineChart from '@/components/charts/lineChart.js'   
import lineChart_full from '@/components/charts/lineChart_full.js'   
import barChart_full from '@/components/charts/barChart_full.js'   
import moment from 'moment'    

import helper from '@/helpers/helpers.js';

export default {
    name: 'chartBlock',
    props: {
        data: { 
            type: [Array],
        },
        TITLE:{ type: [String], default: '' },
        SUBTITLE:{ type: [String] },
        HEIGHT:{ type: [Number], default: 90 },
        CHART_TYPE: { type: [String], default: 'line' }, //line / bar
        CHART: { type: [Number, String], default: 0 },
        CHART_COMPONENT: { type: [String], default: 'regular' },
        startDate: { type: [Number, String], default: moment().subtract(1, 'days').startOf('day').unix() },
        endDate: { type: [Number, String], default: moment().endOf('day').unix() },
        symbol: {type: [String], default: ''},
        sumType: {type: [String], default: 'individual'},
        chartOptions: {type: [String, Boolean, Object], default: false },
    },
    components:{
        lineChart,
        lineChart_full,
        barChart_full
    },
    data: function(){
        return {
            loaded: false,
            error: false,
            CHART_COLUMNS: [],
            CHART_SERIES: [],
            CHART_TOTAL: 0,
            ChartSymbol: '',
            CURRENCY: { currency_symbol: '4', currency_symbol_position: 'front' }, 
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        //this.$watch()
    },
    mounted: function () {
        
        //console.log( this.startDate + " " + this.endDate )
        
        let data = this.data
        this.initiate(data)
        
        //console.log(data)
        
        
    },
    beforeDestroy() {
    },
    methods: {
        initiate(data){
            
            //console.log( this.CHART )
            //console.log(data)
            
            this.loaded = false;
            this.CHART_COLUMNS = []
            
            this.CHART_TOTAL = 0,
            this.CHART_SERIES = []
            
            data.forEach((series, index)=>{
            //for each series
                let seriesData = []
                series.data.forEach((row)=>{
                    if( index == 0 ){
                        this.CHART_COLUMNS.push( row.date )
                    }
                    seriesData.push( row.count )
                })
                
                let color = '#3d6ad2'
                if( series.name.includes('new') ){ color = '#146f17' }
                if( series.name.includes('cancel') ){ color = '#ff0000' }
                if( series.name.includes('reactiv') ){ color = '#f57f59' }
                
                this.CHART_SERIES.push( { label: series.name, data: seriesData, backgroundColor: color } )
            //for each series
            })
            
            console.log(this.CHART_COLUMNS)
            console.log(this.CHART_SERIES)
            
            setTimeout(function(){ 
                this.loaded = true;
                //console.log( this.CHART_SERIES )
            }.bind(this), 150 );
            
            
        },
        
        standard(data){
            
            data.forEach((d)=>{
                                        
                this.CHART_TOTAL += parseFloat( d.count )
                //console.log(day)
                //CREATE CHART DATA
                let format = 'YYYY-MM-DD'
                if( d.date.length == 7 ){
                    format = 'YYYY-MM'
                }
                
                
                let date = d.date
                if( d.datetime ){
                    date = helper.formatDate( d.datetime, 'MMM D' )
                }

                this.CHART_COLUMNS.push(date)
                this.CHART_SERIES.push(d.count)

            })
            
        },
        
        dailyStats(data){
            //console.log(data)
            //let data = this.data
            //data.sort((a, b) => a.datetime - b.datetime);
            //data = this.groupSalesBy(data );
            //console.log(data)
            let data_A = data[0]
            let data_B = data[1]
            if( data_A ){
                //console.log(data_A)
                data_A.data.forEach((day) => {

                    this.CHART_TOTAL += day.count
                    //console.log(day)
                    //CREATE CHART DATA
                    this.CHART_COLUMNS.push(day.day)
                    this.CHART_SERIES.push(day.count)

                });
            }
                
                
            
            
        },
        
        formatDate(datetime){
            //return this.$moment.unix(datetime).format( 'HH:mm MMM D, YYYY' )
            return helper.formatDate( datetime )
        },
        renderAmount( amount ){
            
            if( amount == '-' ){
                return "-"
            }
            
            amount = parseFloat( amount )
            //console.log(amount)
            
            if( amount % 1 === 0 ){
                amount = amount
            }else{
                amount = amount.toFixed(2)
            }
            
            amount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            
            if( this.symbol == '$' ){
                //{{symbol}}{{ CHART_TOTAL }}
                //this.CURRENCY = helper.getCurrency()
                if( helper.getCurrency().currency_symbol_position == 'back' ){
                    return amount + helper.getCurrency().currency_symbol
                }else{
                    return helper.getCurrency().currency_symbol + "" + amount
                }
            }else{
                return amount
            }
            
        },
        
        groupSalesBy( data, groupBy = null ){
            
            if(  data ){
                /*
                let group;
                if( groupBy == null || groupBy == 'days' ){
                    group = 'DD'
                }else if( groupBy == 'hours' ){
                    group = 'HH'
                }
                */
                let format, group;
                if( groupBy == null ){
                    
                    if( ( this.endDate - this.startDate ) < ( 60*60*24 ) ){
                        group = 'HH:00 MMM D';
                        groupBy = 'hours'
                        format = 'HH:00 MMM D'
                    }else{
                        group = 'MMM D';
                        groupBy = 'days'
                        format = 'MMM D'
                    }
                    
                }else{
                    if( groupBy == 'hours' ){
                        group = 'HH:00 MMM D';
                        groupBy = 'hours'
                        format = 'HH:00 MMM D'
                    }
                }
                //console.log( (this.endDate - this.startDate ) +" vs "+ ( 60*60*48 )  )
                //console.log(groupBy)
                
                let timezone = helper.getAccountTimezone()
                let startDate = this.$moment.unix(this.startDate)
                let endDate = this.$moment.unix(this.endDate)
                let max = endDate.diff(startDate, groupBy)
                
                let final = []
                for( let i = 0; i <= max; i++ ){
                    let G = { datetime: startDate.format( group ), date: startDate.format( format ), count: 0, orders: [] }
                    final.push( G )    
                    
                    startDate.add(1, groupBy)
                }
                
                data.forEach((sale)=>{
                    //let date = this.$moment.unix(sale.datetime).tz(timezone).format( format )
                    let date = helper.formatDate( sale.datetime, format )
                    //console.log(format + " " + date)
                    
                    final.forEach((day)=>{
                        if( day.date == date ){
                            day.count += 1
                            day.orders.push( sale )
                        }
                    })
                })
                
                /*
                // this gives an object with dates as keys
                const groups = data.reduce((groups, item) => {
                    //const date = game.daetetime.split('T')[0];
                    //let datetime = this.$moment.unix(item.datetime).format( group )
                    let date = this.$moment.unix(item.datetime).format( group )
                    console.log(date)
                    
                    if (!groups[date]) {
                        groups[date] = [];
                    }
                    
                    groups[date].push(item);
                    return groups;
                }, {});

                // Edit: to add it in the array format instead
                
                const groupArrays = Object.keys(groups).map((date) => {
                    
                    return {
                        date,
                        //revenue: revenue,
                        count: groups[date].length,
                        orders: groups[date]
                    };
                    
                });

                //console.log( groupArrays )
                
               
                let d = this.$moment.unix(this.startDate)
                for( let i = 0; i <= max; i++ ){
                    let found = false
                    //console.log( d.format( 'HH:mm MMM D' ) )
                    groupArrays.map((day) => {
                        console.log( d.format( group ) +" - "+ day.date )
                        console.log( d.format( group ) +" - "+ moment(day.date, 'HH:mm MMM D').format( group ) )
                        
                        //CHECK IF CURRENT ITERATION DATE IS = TO CONVERSION DATE
                        if( d.format( group ) == moment(day.date, 'HH:mm MMM D').format( group ) ){
                            //day.date = d.format(format)
                            //final.push(day)
                            //console.log(day)
                            found = day
                        }else{
                            //final.push( { datetime: d.format( group ), date: d.format( format ), count: 0, orders: [] } )
                            //console.log({ datetime: d.format( group ), date: d.format( format ), count: 0, orders: [] })
                        }
                
                    });
                    
                    if( found ){
                        final.push(found)
                    }else{
                        final.push( { datetime: d.format( group ), date: d.format( format ), count: 0, orders: [] } )
                    }
                                        
                    d.add(1, groupBy)
                    
                }
                
                console.log(final);
                
                //fill empty dates
                */
                //console.log(final)
                return final
                
            }   
            
        },
        
        
        TodaySales(data){
            
            //let data = this.data
            data.sort((a, b) => a.datetime - b.datetime);
            data = this.groupSalesBy(data, 'hours' );
            
            //console.log(data)
            
            let yesterday = null;
            let result = data.map((day, i) => {
                
                //console.log( day.datetime )
                
                //CREATE CHART DATA
                //this.CHART_COLUMNS.push(day.datetime)
                //console.log(last + " vs "+ yesterday )
                if( i == 0 ){
                    yesterday = moment(day.date, 'HH:mm MMM D').format('DD')
                }
                
                if( moment(day.date, 'HH:mm MMM D').format('DD') == yesterday ){
                    //console.log( day.date +" push to yesterday " + day.count )
                    this.CHART_COLUMNS.push( moment(day.date, 'HH:mm MMM D').format('HH:00') )
                    
                    
                }else{
                    //console.log( day.date +" push to today " + day.count )
                    //console.log( day )
                    this.CHART_TOTAL += day.count
                    if( this.sumType == 'progressive' ){
                        this.CHART_SERIES.push( this.CHART_TOTAL )
                    }else{
                        this.CHART_SERIES.push(day.count)
                    }
                    
                }
                
                return day;
                
            });
            
        },
        
        
        TodayRevenue(data){
            
            //let data = this.data
            data.sort((a, b) => a.date - b.date);
            data = this.groupSalesBy(data, 'hours');
            
            let yesterday = null;
            let result = data.map((day, i) => {
        
                //console.log( day.datetime )
                
                if( i == 0 ){
                    yesterday = moment(day.date, 'HH:mm MMM D').format('DD')
                }
                
                let revenue = 0;
                day.orders.forEach(item => {
                    if( item.status != 'refunded' && item.status != 'failed' ){
                        revenue += Number(item.price)
                    }
                })
                day.revenue = revenue
                
                if( moment(day.date, 'HH:mm MMM D').format('DD') == yesterday ){
                    this.CHART_COLUMNS.push( moment(day.date, 'HH:mm MMM D').format('HH:00') )
     
                }else{
                    
                    this.CHART_TOTAL += revenue
                    
                    if( this.sumType == 'progressive' ){
                        this.CHART_SERIES.push( this.CHART_TOTAL )
                    }else{
                        this.CHART_SERIES.push(revenue)
                    }
                }
                
                return day;
                
            });
            
            //this.CHART_TOTAL = +this.CHART_TOTAL
            
            this.CHART_TOTAL = this.CHART_TOTAL.toFixed(2)
            
        },
        
        numberOfCustomersByDay(data){
            
            data = data.filter( x => x.status != 'refunded' && x.status != 'failed' );
            
            let uniqueAll = helper.uniqueItems( data, 'leadID' )
            
            //let data = this.data
            data.sort((a, b) => a.datetime - b.datetime);
            data = this.groupSalesBy( data );
            //console.log(data)
            
            let result = data.map((day) => {

                let count = 0
                let unique = helper.uniqueItems( day.orders, 'leadID' )
                
                //CREATE CHART DATA
                this.CHART_COLUMNS.push(day.date)
                this.CHART_SERIES.push(unique)

                return day;
                
            });
            
            this.CHART_TOTAL = uniqueAll
            
        },
        
        numberOfSalesByDay(data){
            
            //let data = this.data
            data.sort((a, b) => a.datetime - b.datetime);
            data = this.groupSalesBy(data );
            
            //console.log(data)
            
            let result = data.map((day) => {

                this.CHART_TOTAL += day.count
                
                //CREATE CHART DATA
                this.CHART_COLUMNS.push(day.date)
                this.CHART_SERIES.push(day.count)

                return day;
                
            });
            
            
        },
        revenueByDay(data){
            
            //let data = this.data
            data.sort((a, b) => a.datetime - b.datetime);
            data = this.groupSalesBy(data );
            
            let result = data.map((day) => {
                let revenue = 0;
                day.orders.forEach(item => {
                    if( item.status != 'refunded' && item.status != 'failed' ){
                        revenue += Number(item.price)
                    }
                        
                })
        
                this.CHART_TOTAL += revenue
                //CREATE CHART DATA
                this.CHART_COLUMNS.push(day.date)
                this.CHART_SERIES.push(revenue)
                
                day.revenue = revenue
                return day;
                
            });
            
            this.CHART_TOTAL = this.CHART_TOTAL.toFixed(2)
            
        },

        goToResource(resource){
            
            helper.goToResource(resource)
            
        }
        
    },
    computed: {
    },
    watch: {
        'data': function(newVal, oldVal) {
            //console.log('value changed from ' + oldVal + ' to ' + newVal);
            if( oldVal != newVal ){
                this.loaded = false
                this.initiate(newVal)
                
            }
            //console.log( this.CHART_COLUMNS )
            //console.log( this.CHART_SERIES )
            
            //this.chartData.labels = this.CHART_COLUMNS
            //this.chartData.datasets[0].data = this.CHART_SERIES
            
        },
        
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .template-loading{
        margin-top: 50px;
        margin-bottom: 100px;
    }
    
    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/components/chartBlock-bar.vue